module.exports = __webpack_public_path__ + "img/GT.e6aa6aab.svg";